import Layout from '@/components/Layout';
import client from '@/config/sanityClient';
import { useState, useEffect } from 'react';
import Link from 'next/link';

import {
  TitleContainer,
  QuoteRow,
  QuoteColumn,
  Quote,
  hasImage,
} from '@/components/Learning';

function TeachingPage({ APIpictures }: any) {
  const [images, setImages]: any = useState([]);

  useEffect(() => {
    APIpictures && setImages(APIpictures);
  }, [APIpictures]);

  const manifestingGuide = [
    `1. You decide on exactly what job you want: The type of work: manual, computer, hands on, remote, office based, industrial. Learn all you can about the type of work, research the people that have a role like this and learn what characteristics and skills they possess.`,
    `2. Now imagine that you are that person. How would that person act, how would they behave. Imagine the type of tasks they would undertake during there work and what they do outside of there work, study, improve their skills, practice them, seek out mentors, coaches, read books, blogs, watch informational videos, take courses.`,
    `3. Imagine how comfortable your new job feels and how deserving you are of it, imagine being in the work environment, the touch, the smell, the visceral feelings you get knowing you are working in the environment that you imagined.`,
    `4. Imagine a scenario that implies the wish fulfilled: "Hey, you did an amazing job on that piece of work, it has made a massive positive impact on our organisation." If you work with other people, you could imagine going for lunch with your colleagues or if in sales, meeting your client and having some jokes with them and closing the deal.`,
    `5. Imagine signing your employment contract and receiving your salary or invoice payments as this impies your wish is fulfilled.`,
    `6. Give thanks for your new job, because the act of gratitude indicates you have recieved the gift, that it has already happened. Practice this daily, when you are in a `,
    ` You could be resting, relaxing, when you wake up, just before bed time, in a relaxing bath or taking a walk.`,
  ];

  return (
    <Layout
      title={'Guide to manifesting a job'}
      description={`Neville Gododard's method for A guide on how to manifesting a job`}
    >
      <TitleContainer>
        <h2>Neville Goddard</h2>
        <h1>HOW TO MANIFEST A JOB</h1>
      </TitleContainer>
      <QuoteRow>
        <QuoteColumn>
          <Quote>{manifestingGuide[0]}</Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 2, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          <Quote>{manifestingGuide[1]}</Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 5, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          <Quote>{manifestingGuide[2]}</Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 4, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          <Quote>{manifestingGuide[3]}</Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 3, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          <Quote>{manifestingGuide[4]}</Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 0, 'long')}</QuoteColumn>
      </QuoteRow>
      <QuoteRow>
        <QuoteColumn>
          <Quote>
            {manifestingGuide[5]}
            <Link href="/neville-goddard/state-akin-to-sleep">
              <span className="underline">
                <strong>state akin to sleep.</strong>
              </span>
            </Link>
            {manifestingGuide[6]}
          </Quote>
        </QuoteColumn>
        <QuoteColumn>{hasImage(images, 1, 'long')}</QuoteColumn>
      </QuoteRow>
    </Layout>
  );
}

export default TeachingPage;

export async function getStaticProps() {
  const picturesQuery = `*[_type == 'picture' && theme->name == 'job' ]{
    description,
    'imageUrl': picture.asset->url
  }`;
  const APIpictures = await client.fetch(picturesQuery);
  return {
    props: {
      APIpictures,
    },
  };
}
